import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';
export function registerItemsToSynchronizeListItemResourceBundleDe(i18next: i18n): void {
  i18next.addResourceBundle('de', 'record-it-components', {
    synchronization: {
      ItemsToSynchronizeListItem: {
        idLabel: 'ID:'
      }
    }
  } as Partial<CustomTypeOptions['resources']['record-it-components']>, true);
}